import React, { useEffect } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle, XCircle, ArrowLeft } from '@untitled-ui/icons-react'

// Landing page after Xendit hosted checkout. URL pattern set by SAW
// LocalBilling.buildRedirectUrls:
//   success → /billing/success?invoice=<invoice_id>
//   failure → /billing/failure?invoice=<invoice_id>
//
// The actual invoice/payment state lives in SAW DB and gets updated by the
// Xendit webhook (async). Both pages here are purely informational — the
// HR user navigates back to Company → Billing tab to see the updated state.

function PaymentResult({ variant }) {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const invoiceId = params.get('invoice')

  const isSuccess = variant === 'success'

  // Auto-bounce after 8s in case the user just wants to move on.
  useEffect(() => {
    const t = setTimeout(() => navigate('/company'), 8000)
    return () => clearTimeout(t)
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50/50 p-6">
      <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-2xl border border-gray-200 bg-white p-10 shadow-sm">
        {isSuccess ? (
          <CheckCircle className="size-16 text-success/600" stroke="currentColor" />
        ) : (
          <XCircle className="size-16 text-error/600" stroke="currentColor" />
        )}

        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-xl font-semibold text-gray-900">
            {isSuccess ? 'Payment successful' : 'Payment failed'}
          </h1>
          <p className="text-sm text-gray-600">
            {isSuccess
              ? 'Your payment is being processed by our system. The subscription / quota becomes active as soon as the payment gateway notification is received.'
              : 'The payment could not be completed. Please try again or choose another payment method.'}
          </p>
          {invoiceId ? (
            <p className="mt-2 break-all text-xs text-gray-400">
              Invoice ref: {invoiceId}
            </p>
          ) : null}
        </div>

        <div className="flex w-full flex-col gap-2">
          <Link
            to="/company"
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-brand/600 px-4 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-brand/700"
          >
            <ArrowLeft size={16} />
            Back to Company
          </Link>
          <p className="text-center text-xs text-gray-400">
            Redirecting automatically in 8 seconds…
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentResult
